import { useState, useEffect } from "react";
import axios from "axios";
import { PieChart, Pie, Cell } from "recharts";

const baseUrl =
  process.env.REACT_APP_PUBLIC_API_URL 

  
export const EDUCATION_CHART_COLORS = [
  "#F2A93B",
  "#3F7D20",
  "#a5259a",
  "#24188f",
  "#db203f",
  "#1eced4",
];

const EducationLevel = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    axios
      .get(`${baseUrl}/education-level`)
      .then((response) => {
        const res = response.data;
        if (res.success && Array.isArray(res.education)) {
          setData(
            res.education.map((item) => ({
              name: item.name,
              value: item.percent,
            }))
          );
        }
      })
      .catch((error) => console.error("Error fetching education level:", error));
  }, []);

  const chartData = data.length > 0 ? data : [{ name: "No data", value: 1 }];
  const hasData = data.length > 0;

  return (

    <div className="w-full">
      <h3 className="text-xl font-semibold text-gray-900 tracking-tight mb-1">
        Educational Level
      </h3>
      <p className="text-sm text-gray-500 mb-6">
        Highest Level of Education attained
      </p>

      <div className="flex justify-center">
        <PieChart width={220} height={220}>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            innerRadius={60}
            outerRadius={90}
            paddingAngle={hasData ? 3 : 0}
            dataKey="value"
          >
            {chartData.map((_, index) => (
              <Cell
                key={index}
                fill={hasData ? EDUCATION_CHART_COLORS[index % EDUCATION_CHART_COLORS.length] : "#e5e7eb"}
              />
            ))}
          </Pie>
        </PieChart>
      </div>
    </div>
  );
};

export default EducationLevel;
